import React, { Component } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import './../ModernApp.css';
import './../RecoveryShell.css';
import './../MediaArchive.css';
import { getSocketApiBase, getLoginApiBase } from '../utils/apiBase';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from '../components/Sidebar';
import SearchResultsSidebar from '../components/SearchResultsSidebar';
import ModernHeader from '../components/ModernHeader';
import MainVideoPlayer from '../components/MainVideoPlayer';
import QuadVideoPlayer from '../components/QuadVideoPlayer';
import HomePage from '../components/HomePage';
import UploadComponent from '../upload/uploadComponent';
import AgeGate from '../components/AgeGate';
import AdFooter from '../components/AdFooter';
import SocialLinks from '../components/SocialLinks';
import AgeGateManager from '../utils/ageGate';
import { captureAnalytics } from '../analytics';

import { io } from 'socket.io-client';
// import getenv from 'getenv'
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';

// const socketHost = getenv('EPIC_SERVER_SERVICE_SERVICE_HOST');

// console.log('Host is: ', socketHost);

const socketUrl = getSocketApiBase();
const isImpeccableReview = new URLSearchParams(window.location.search).get('review') === '1';
const reviewVideos = Array.from({ length: 12 }, (_, index) => ({
    display_id: `review-${index + 1}`,
    title: [
        'Live Room Session — Episode 14',
        'Studio Warmup — Solo Piano Take',
        'Ambient Jam — Nightline Session',
        'Backstage Rehearsal — Full Run',
        'Acoustic Set — Old Vinyl Studio',
        'Electronic Live — Modular Nights',
        'Vocal Recording — Take & Talk',
        'Drum Clinic — Groove Dialogue',
        'Songwriter Session — Roundtable',
        'Bass Lesson — Foundation Work',
        'Indie Folk Live — Small Room',
        'Mixing Session — Behind the Desk'
    ][index],
    uploader: ['The Session Archive', 'Piano House Collective', 'Echo Room Recordings'][index % 3],
    duration: ['28:47', '11:22', '33:10', '19:56'][index % 4],
    view_count: 14000 - (index * 730),
    upload_date: index === 0 ? 'Added May 12, 2024' : undefined,
    reviewPoster: index === 0 ? '/media/player-media.png' : undefined,
    thumbnailSprite: '/media/result-thumbnails.png',
    thumbnailIndex: index
}));
console.log('🌐 Socket.io connecting to URL:', socketUrl);
console.log('🔍 Environment variable REACT_APP_EPIC_SERVER_SERVICE_SERVICE_HOST:', process.env.REACT_APP_EPIC_SERVER_SERVICE_SERVICE_HOST);
console.log('🖥️ Window hostname:', window.location.hostname);

const socket = io(socketUrl, {
    autoConnect: !isImpeccableReview && !window.__IMPECCABLE_REVIEW__,
    auth: {
        ageGateToken: AgeGateManager.getAgeGateToken()
    },
    query: {
        ageGateToken: AgeGateManager.getAgeGateToken()
    }
});

// Make socket available globally for age gate reconnection
window.socket = socket;

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loggedIn: false,
            email: '',
            password: '',
            name: '',
            confirmPassword: '',
            loginModalShow: false,
            registerModalShow: false,
            uploadModalShow: false,
            search_string: '',
            selectedVideo: null,
            selectedVideos: [null, null, null, null],
            activeQuadSlot: 0,
            viewMode: 'single',
            currentPage: 'videos',
            showAgeGate: false,
            sidebarOpen: false,
            showSearchResults: false,
            searchSidebarCollapsed: false,
            loading: false,
            searchPage: 1,
            searchHasNext: false,
            adFooterCollapsed: window.matchMedia('(max-width: 768px)').matches,
            connectionState: 'connecting',
            searchError: ''
        }

        this.activeSearchRequestId = null;
        this.searchTimeout = null;
        this.videoResolveTimers = new Map();
        this.resolveAutoRetriesRemaining = 0;

        if (isImpeccableReview) {
            this.state.search_string = 'music';
            this.state.showSearchResults = true;
            this.state.selectedVideo = reviewVideos[0];
            this.state.connectionState = 'connected';
        }
    }

    componentDidMount() {
        console.log("🔌 Attempting to connect to Socket.io server...");
        
        socket.on("connect", () => {
            console.log("✅ Socket.io CONNECTED successfully!");
            console.log("🆔 Socket ID:", socket.id);
            this.setState({ connectionState: 'connected', searchError: '' });
        });
        
        socket.on("disconnect", (reason) => {
            console.log("❌ Socket.io DISCONNECTED:", reason);
            this.setState({ connectionState: 'disconnected' });
        });
        
        socket.on("connect_error", (error) => {
            console.log("🚨 Socket.io CONNECTION ERROR:", error);
            this.setState({
                connectionState: 'disconnected',
                loading: false,
                searchError: 'Search is temporarily offline. Check your connection and try again.'
            });
        });
        
        socket.on("search-term-result", (res) => {
            console.log("🔥 Received search result:", res);
            if (res.requestId && res.requestId !== this.activeSearchRequestId) {
                return;
            }

            // Handle search errors
            if (res.error) {
                console.log("🚨 Search error:", res.error);
                if (res.requiresAgeGate) {
                    // Show age gate
                    this.setState({ showAgeGate: true });
                } else if (res.error === 'Authentication required') {
                    // Show login modal
                    this.setState({ loginModalShow: true });
                }
                toast.error(res.message || res.error);
                this.setState({ loading: false, searchError: res.message || res.error });
                return;
            }
            
            const obj = this.props.videos.find(x => x.display_id === res.display_id);
            if (!obj) {
                console.log("✅ Adding new video to store:", res.title);
                this.props.dispatch({ type: 'ADD_VIDEO', payload: res });
                const updates = {
                    loading: false,
                    searchError: '',
                    showSearchResults: true,
                    currentPage: 'videos'
                };
                this.setState(updates);
            } else {
                console.log("⚠️ Video already exists:", res.title);
            }
        });

        socket.on("search-term-complete", (payload) => {
            if (payload?.requestId && payload.requestId !== this.activeSearchRequestId) {
                return;
            }
            const videos = this.props.videos || [];
            captureAnalytics('search_completed', {
                page: Number(payload?.page) || this.state.searchPage,
                result_count: videos.length,
                has_next: Boolean(payload?.hasNext),
                provider_count: new Set(videos.map((video) => video?.source).filter(Boolean)).size
            });
            this.setState((state) => ({
                loading: false,
                searchPage: Number(payload?.page) || state.searchPage,
                searchHasNext: Boolean(payload?.hasNext)
            }));
        });

        socket.on("search-term-error", (payload) => {
            if (payload?.requestId && payload.requestId !== this.activeSearchRequestId) {
                return;
            }
            captureAnalytics('search_failed', {
                failure_type: 'provider_error',
                page: this.state.searchPage
            });
            this.setState({
                loading: false,
                searchHasNext: false,
                searchError: payload?.message || payload?.error || 'Search failed. Try again.'
            });
            toast.error(payload?.message || payload?.error || 'Search failed.');
        });

        socket.on("resolve-video-result", this.handleResolveVideoResult);
        
        if (sessionStorage.getItem('logged_in') === 'true' || sessionStorage.getItem('logged_in') === true) {
            const userEmail = sessionStorage.getItem('user_email');
            this.setState({
                loggedIn: true,
                email: userEmail || ''
            })
        }
        
        // Check age gate status
        this.checkAgeGate();
    }

    componentDidUpdate(props) {
        console.log(props.videos);
    }

    componentWillUnmount() {
        window.clearTimeout(this.searchTimeout);
        socket.off('connect');
        socket.off('disconnect');
        socket.off('connect_error');
        socket.off('search-term-result');
        socket.off('search-term-complete');
        socket.off('search-term-error');
        socket.off('resolve-video-result', this.handleResolveVideoResult);
        this.videoResolveTimers.forEach((timer) => window.clearTimeout(timer));
        this.videoResolveTimers.clear();
    }

    createSearchRequestId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    changeSearchKeyWord = (search_string) => {
        this.setState({
            search_string: search_string
        })
    }

    handleUploadModalShow = () => {
        this.setState({ uploadModalShow: true });
    }

    handleUploadModalClose = () => {
        this.setState({ uploadModalShow: false });
    }

    buildUserUploadVideo = (userVideo) => {
        const userId = sessionStorage.getItem('user_id');
        const minioPath = userVideo?.minioPath;
        if (!userId || !minioPath) {
            return null;
        }

        const ageGateToken = AgeGateManager.getAgeGateToken() || '';
        const params = new URLSearchParams({
            path: minioPath,
            ageGateToken
        });
        const url = `${getSocketApiBase()}/user-upload/${userId}?${params.toString()}`;

        return {
            display_id: `upload-${userVideo.id}`,
            title: userVideo.videoTitle || userVideo.videoFilename || 'Uploaded video',
            duration: userVideo.duration || '0:00',
            uploader: userVideo.uploader?.name || 'You',
            thumbnail: userVideo.thumbnailPath || '',
            url,
            playable: true,
            isUserUpload: true,
            minioPath,
            fileSize: userVideo.fileSize,
            upload_date: userVideo.uploadDate
        };
    };

    placeVideoInPlayer = (video, placementOptions = {}) => {
        const shouldCloseMobileResults = window.matchMedia('(max-width: 768px)').matches;
        if (this.state.viewMode === 'single') {
            this.setState({
                selectedVideo: video,
                showSearchResults: shouldCloseMobileResults
                    ? false
                    : this.state.showSearchResults
            });
        } else {
            this.setState((state) => {
                const forcedSlot = Number.isInteger(placementOptions.quadSlot)
                    && placementOptions.quadSlot >= 0
                    && placementOptions.quadSlot < 4
                    ? placementOptions.quadSlot
                    : null;
                const targetSlot = forcedSlot ?? state.activeQuadSlot;
                const selectedVideos = [...state.selectedVideos];
                selectedVideos[targetSlot] = video;
                const nextEmptySlot = selectedVideos.findIndex((item) => item === null);

                return {
                    selectedVideos,
                    activeQuadSlot: placementOptions.preserveActiveQuadSlot
                        ? state.activeQuadSlot
                        : (nextEmptySlot >= 0 ? nextEmptySlot : targetSlot),
                    showSearchResults: shouldCloseMobileResults
                        ? false
                        : state.showSearchResults
                };
            });
        }
    };

    replacePendingVideo = (requestId, nextVideo) => {
        const replace = (video) => (
            video?.resolve_request_id === requestId
                ? { ...video, ...nextVideo }
                : video
        );
        this.setState((state) => ({
            selectedVideo: replace(state.selectedVideo),
            selectedVideos: state.selectedVideos.map(replace)
        }));
    };

    handleResolveVideoResult = (payload) => {
        const requestId = payload?.requestId;
        if (!requestId) return;

        const timer = this.videoResolveTimers.get(requestId);
        if (timer) {
            window.clearTimeout(timer);
            this.videoResolveTimers.delete(requestId);
        }

        if (payload?.requiresAgeGate) {
            this.setState({ showAgeGate: true });
        }

        if (payload?.error || !payload?.video?.url) {
            const failedQuadSlot = this.state.selectedVideos.findIndex(
                (video) => video?.resolve_request_id === requestId
            );
            const failedVideo = this.state.selectedVideo?.resolve_request_id === requestId
                ? this.state.selectedVideo
                : this.state.selectedVideos[failedQuadSlot];

            if (this.resolveAutoRetriesRemaining > 0 && failedVideo?.display_id) {
                const list = this.props.videos || [];
                const failedIndex = list.findIndex((v) => v.display_id === failedVideo.display_id);
                const next = list.slice(failedIndex + 1).find((v) => v.source_url);
                if (next) {
                    this.resolveAutoRetriesRemaining -= 1;
                    toast.info('That source failed — trying the next result…');
                    this.handleVideoSelect(
                        next,
                        failedQuadSlot >= 0
                            ? { quadSlot: failedQuadSlot, preserveActiveQuadSlot: true, autoRetry: true }
                            : { autoRetry: true }
                    );
                    return;
                }
            }

            captureAnalytics('video_prepare_failed', {
                provider: failedVideo?.source || 'unknown',
                view_mode: this.state.viewMode,
                auto_retries_remaining: this.resolveAutoRetriesRemaining
            });
            this.replacePendingVideo(requestId, {
                resolve_request_id: requestId,
                resolving: false,
                resolveError: payload?.message || 'This source could not be prepared. Pick another result in the list or try a different search.'
            });
            return;
        }

        captureAnalytics('video_ready', {
            provider: payload.video?.source || 'unknown',
            view_mode: this.state.viewMode
        });
        this.replacePendingVideo(requestId, {
            ...payload.video,
            resolve_request_id: requestId,
            resolving: false,
            resolveError: ''
        });
    };

    handleVideoSelect = (video, placementOptions = {}) => {
        const resultPosition = (this.props.videos || []).findIndex(
            (result) => result?.display_id === video?.display_id
        );
        captureAnalytics('video_selected', {
            provider: video?.source || (video?.isUserUpload ? 'user_upload' : 'unknown'),
            result_position: resultPosition >= 0 ? resultPosition + 1 : null,
            search_page: this.state.searchPage,
            view_mode: this.state.viewMode,
            target_slot: this.state.viewMode === 'quad'
                ? (placementOptions.quadSlot ?? this.state.activeQuadSlot) + 1
                : null,
            requires_resolution: !(video?.playable && video?.url),
            auto_retry: Boolean(placementOptions.autoRetry)
        });

        if (video?.playable && video?.url) {
            this.setState({ currentPage: 'videos' });
            this.placeVideoInPlayer(video, placementOptions);
            return;
        }

        if (video?.minioPath || video?.isUserUpload) {
            const normalized = video?.url ? video : this.buildUserUploadVideo(video);
            if (normalized?.url) {
                this.setState({ currentPage: 'videos' });
                this.placeVideoInPlayer(normalized, placementOptions);
                return;
            }
        }

        const sourceUrl = video?.source_url;
        if (!sourceUrl) {
            this.placeVideoInPlayer({
                ...video,
                title: video?.title || video?.videoTitle,
                resolving: false,
                resolveError: 'This result has no playable source.'
            }, placementOptions);
            return;
        }

        this.setState({ currentPage: 'videos' });

        if (!socket.connected) {
            socket.connect();
        }

        const requestId = this.createSearchRequestId();
        this.placeVideoInPlayer({
            ...video,
            resolve_request_id: requestId,
            resolving: true,
            resolveError: ''
        }, placementOptions);

        socket.emit('resolve-video', {
            requestId,
            sourceUrl,
            provider: video.source,
            sourceId: video.source_id,
            video: {
                display_id: video.display_id,
                title: video.title,
                duration: video.duration,
                uploader: video.uploader,
                thumbnail: video.thumbnail,
                view_count: video.view_count,
                source: video.source,
                source_label: video.source_label,
                source_id: video.source_id
            }
        });

        const timer = window.setTimeout(() => {
            this.videoResolveTimers.delete(requestId);
            this.replacePendingVideo(requestId, {
                ...video,
                resolve_request_id: requestId,
                resolving: false,
                resolveError: 'Preparing this video took too long. Choose another result.'
            });
        }, 35000);
        this.videoResolveTimers.set(requestId, timer);
    };

    handleViewModeChange = (mode) => {
        if (mode !== this.state.viewMode) {
            captureAnalytics('view_mode_changed', {
                previous_mode: this.state.viewMode,
                view_mode: mode,
                loaded_video_count: mode === 'quad'
                    ? this.state.selectedVideos.filter(Boolean).length
                    : (this.state.selectedVideo ? 1 : 0)
            });
        }
        this.setState((state) => {
            if (mode !== 'quad') return { viewMode: mode };
            const firstEmptySlot = state.selectedVideos.findIndex((video) => video === null);
            return {
                viewMode: mode,
                activeQuadSlot: firstEmptySlot >= 0 ? firstEmptySlot : state.activeQuadSlot
            };
        });
    }

    handleActiveQuadSlotChange = (slotIndex) => {
        if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex > 3) return;
        captureAnalytics('quad_target_changed', {
            target_slot: slotIndex + 1,
            loaded_video_count: this.state.selectedVideos.filter(Boolean).length
        });
        this.setState({ activeQuadSlot: slotIndex });
    }

    handlePageChange = (page) => {
        const normalizedPage = page === 'browse' ? 'videos' : page;
        const updates = { currentPage: normalizedPage };
        if (normalizedPage === 'home') {
            updates.showSearchResults = false;
            updates.searchSidebarCollapsed = false;
        }
        this.setState(updates);
    }

    checkAgeGate = () => {
        const shouldShow = AgeGateManager.shouldShowAgeGate();
        this.setState({ 
            showAgeGate: shouldShow
        });
    }

    handleAgeGateVerified = () => {
        this.setState({ 
            showAgeGate: false
        });
    }

    reconnectSocketWithAgeGate = () => {
        const ageGateToken = AgeGateManager.getAgeGateToken();
        if (ageGateToken && socket) {
            // Update socket auth with age gate token
            socket.auth = { ageGateToken };
            socket.disconnect();
            socket.connect();
        }
    }

    toggleSidebar = () => {
        if (!this.state.loggedIn) {
            return;
        }
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }

    closeSidebar = () => {
        this.setState({ sidebarOpen: false });
    }

    closeSearchResults = () => {
        this.setState({ showSearchResults: false, searchSidebarCollapsed: false });
    }

    openSearchResults = () => {
        this.setState({ showSearchResults: true, searchSidebarCollapsed: false });
    }

    handleSearchSidebarCollapse = (isCollapsed) => {
        this.setState({ 
            searchSidebarCollapsed: isCollapsed 
        });
    };

    handleAdFooterToggle = () => {
        this.setState((state) => ({
            adFooterCollapsed: !state.adFooterCollapsed
        }));
    };

    searchVideos = (page) => {
        const searchTerm = this.state.search_string.trim();
        const requestedPage = Number.isInteger(page) && page > 0 ? page : 1;
        if (!searchTerm) {
            this.setState({ searchError: 'Enter a title, keyword, or paste a link.' });
            return;
        }

        captureAnalytics('search_submitted', {
            page: requestedPage,
            input_type: /^https?:\/\//i.test(searchTerm) ? 'url' : 'text'
        });

        if (!socket.connected) {
            socket.connect();
        }

        const requestId = this.createSearchRequestId();
        this.activeSearchRequestId = requestId;

        this.props.dispatch({ type: 'CLEAR_VIDEOS' });

        this.resolveAutoRetriesRemaining = 3;

        this.setState({
            showSearchResults: true,
            currentPage: 'videos',
            loading: true,
            searchPage: requestedPage,
            searchHasNext: false,
            searchError: ''
        });

        socket.emit('search-term', {
            term: searchTerm,
            requestId,
            page: requestedPage
        });

        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = window.setTimeout(() => {
            if (this.state.loading && this.activeSearchRequestId === requestId) {
                captureAnalytics('search_failed', {
                    failure_type: 'timeout',
                    page: requestedPage
                });
                this.setState({
                    loading: false,
                    searchError: 'Search took too long. Try a more specific phrase.'
                });
            }
        }, 12000);
    }

    onBtnClick = () => {
        this.searchVideos(1);
    }

    onSearchPageChange = (page) => {
        if (this.state.loading || page < 1) return;
        captureAnalytics('search_page_changed', {
            previous_page: this.state.searchPage,
            page,
            direction: page > this.state.searchPage ? 'next' : 'previous'
        });
        this.searchVideos(page);
    }

    handleLoginModalClose = () => this.setState({
        loginModalShow: false
    });
    handleRegisterModalClose = () => this.setState({
        registerModalShow: false
    });
    handleRegisterModalShow = () => {
        toast.dismiss();
        this.setState({ registerModalShow: true });
    };
    handleLoginModalShow = () => {
        toast.dismiss();
        this.setState({ loginModalShow: true });
    };

    logout = () => {
        sessionStorage.clear();
        this.setState({
            loggedIn: false,
            email: '',
            currentPage: 'videos',
            sidebarOpen: false
        });
    }

    handleShare = async () => {
        const shareData = {
            title: 'Lick Before You Stick',
            text: this.state.selectedVideo?.title || 'Watch together on Lick Before You Stick',
            url: window.location.href
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(shareData.url);
                toast.success('Link copied');
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                toast.error('Could not share this link.');
            }
        }
    };

    handleValues = (key, value) => {
        this.setState({
            [key]: value
        })
        console.log(this.state);
    }

    ValidateEmail(mail) {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
            return (true)
        }
        return (false)
    }

    handleRegister = async() => {
        if (this.state.name === '') {
            toast.error('Name is required');
            return;
        }
        if (this.state.email === '') {
            toast.error('Email is required');
            return;
        }
        if (!this.ValidateEmail(this.state.email)) {
            toast.error('Email is invalid');
            return;
        }
        if (this.state.password === '') {
            toast.error('Password is required');
            return;
        }
        if (this.state.confirmPassword === '') {
            toast.error('Confirm Password is required');
            return;
        }
        if (this.state.confirmPassword !== this.state.password) {
            toast.error('Password and Confirm Password does not match');
            return;
        }

        const { name, email, password } = this.state;

        try {
            await axios.post(`${getLoginApiBase()}/register`, { name, email, password });
            const loginResponse = await axios.post(`${getLoginApiBase()}/login`, { email, password });
            const user = loginResponse.data?.user;
            if (!user?.id) {
                throw new Error('Login after register did not return user id');
            }

            sessionStorage.setItem('logged_in', true);
            sessionStorage.setItem('user_email', email);
            sessionStorage.setItem('user_id', user.id);
            this.setState({
                loggedIn: true,
                email
            });
            this.handleRegisterModalClose();
            this.reconnectSocketWithAgeGate();
            toast.success('Account created — you are signed in');
        } catch (err) {
            console.log(err);
            toast.error(err.response?.status === 404 ? 'User already registered' : 'Registration failed');
        }
    }

    handleLogin = () => {
        if (this.state.email === '') {
            toast.error('Email is required');
            return;
        }
        if (this.state.password === '') {
            toast.error('Password is required');
            return;
        }

        axios({
            method: 'post',
            url: `${getLoginApiBase()}/login`,
            data: {
                email: this.state.email,
                password: this.state.password
            }
        }).then((response) => {
            toast.success('Success');
            sessionStorage.setItem('logged_in', true);
            sessionStorage.setItem('user_email', this.state.email);
            sessionStorage.setItem('user_id', response.data.user.id);
            this.handleLoginModalClose();
            this.setState({
                loggedIn: true,
                email: this.state.email
            });
            // Reconnect socket with age gate token
            this.reconnectSocketWithAgeGate();
        }).catch((err) => {
            console.log(err);
            toast.error('Invalid Credentials');
        });
    }

    render() {
        const visibleVideos = isImpeccableReview ? reviewVideos : this.props.videos;

        // Show age gate first before any content
        if (this.state.showAgeGate && !isImpeccableReview) {
            return <AgeGate onVerified={this.handleAgeGateVerified} />;
        }
        
        return (
            <div
                className={[
                    'modern-app',
                    isImpeccableReview ? 'impeccable-review' : '',
                    'with-footer',
                    this.state.adFooterCollapsed ? 'footer-collapsed' : ''
                ].filter(Boolean).join(' ')}
            >
                <ToastContainer position="bottom-right" limit={3} autoClose={4000} />
                
                {this.state.loggedIn && (
                <Sidebar 
                    loggedIn={this.state.loggedIn}
                    logout={this.logout}
                    handleUploadShow={this.handleUploadModalShow}
                    currentPage={this.state.currentPage}
                    onPageChange={this.handlePageChange}
                    isOpen={this.state.sidebarOpen}
                    onClose={this.closeSidebar}
                />
                )}
                
                <SearchResultsSidebar 
                    videos={visibleVideos}
                    loading={this.state.loading}
                    onVideoSelect={this.handleVideoSelect}
                    selectedVideo={
                        this.state.viewMode === 'quad'
                            ? this.state.selectedVideos[this.state.activeQuadSlot]
                            : this.state.selectedVideo
                    }
                    query={this.state.search_string}
                    isVisible={this.state.showSearchResults}
                    onClose={this.closeSearchResults}
                    onCollapse={this.handleSearchSidebarCollapse}
                    page={this.state.searchPage}
                    hasPrevious={this.state.searchPage > 1}
                    hasNext={this.state.searchHasNext}
                    onPageChange={this.onSearchPageChange}
                    targetScreen={
                        this.state.viewMode === 'quad'
                            ? this.state.activeQuadSlot + 1
                            : null
                    }
                />
                
                <div className={`modern-main full-width ${this.state.showSearchResults ? 'with-search-sidebar' : ''} ${this.state.searchSidebarCollapsed ? 'collapsed' : ''}`}>
                    <ModernHeader
                        searchString={this.state.search_string}
                        changeSearchKeyWord={this.changeSearchKeyWord}
                        onBtnClick={this.onBtnClick}
                        handleLoginShow={this.handleLoginModalShow}
                        loggedIn={this.state.loggedIn}
                        userEmail={this.state.email}
                        viewMode={this.state.viewMode}
                        onViewModeChange={this.handleViewModeChange}
                        showHamburger={this.state.loggedIn}
                        onToggleSidebar={this.toggleSidebar}
                        sidebarOpen={this.state.sidebarOpen}
                        searchError={this.state.searchError}
                        connectionState={this.state.connectionState}
                    />
                    
                    <div className="modern-content">
                        {this.state.currentPage === 'videos'
                            && !this.state.showSearchResults
                            && visibleVideos.length > 0 && (
                            <button
                                type="button"
                                className="mobile-results-return"
                                onClick={this.openSearchResults}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M8 6h12M8 12h12M8 18h12" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round"/>
                                    <circle cx="4" cy="6" r="1" fill="currentColor"/>
                                    <circle cx="4" cy="12" r="1" fill="currentColor"/>
                                    <circle cx="4" cy="18" r="1" fill="currentColor"/>
                                </svg>
                                <span>Back to results</span>
                                <span className="mobile-results-count">{visibleVideos.length}</span>
                            </button>
                        )}
                        {this.state.currentPage === 'home' ? (
                            <HomePage
                                loggedIn={this.state.loggedIn}
                                userEmail={this.state.email}
                                handleLoginShow={this.handleLoginModalShow}
                                onVideoSelect={this.handleVideoSelect}
                            />
                        ) : (
                            <>
                                {this.state.viewMode === 'single' ? (
                                    <MainVideoPlayer 
                                        video={this.state.selectedVideo}
                                        catalogHasResults={
                                            this.state.showSearchResults && visibleVideos.length > 0
                                        }
                                    />
                                ) : (
                                    <QuadVideoPlayer 
                                        videos={this.state.selectedVideos}
                                        activeSlot={this.state.activeQuadSlot}
                                        onActiveSlotChange={this.handleActiveQuadSlotChange}
                                    />
                                )}
                            </>
                        )}
                        <SocialLinks className="mobile-socials" />
                    </div>
                </div>

                <AdFooter
                    isCollapsed={this.state.adFooterCollapsed}
                    onToggleCollapse={this.handleAdFooterToggle}
                />
                
                <>
                    <Modal show={this.state.loginModalShow} onHide={this.handleLoginModalClose} centered className="modern-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>Login</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        name="email"
                                        placeholder="Enter email"
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.handleValues('email', e.target.value);
                                        }} />
                                    <Form.Text className="text-muted">
                                        We'll never share your email with anyone else.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        name="password"
                                        placeholder="Password"
                                        value={this.state.password}
                                        onChange={(e) => {
                                            this.handleValues('password', e.target.value);
                                        }}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="link"
                                onClick={() => {
                                    this.handleLoginModalClose();
                                    this.handleRegisterModalShow();
                                }}
                            >
                                Create account
                            </Button>
                            <Button variant="secondary" onClick={this.handleLoginModalClose}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={this.handleLogin}>
                                Login
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.registerModalShow} onHide={this.handleRegisterModalClose} centered className="modern-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>Registration</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group controlId="formBasicName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="name"
                                        placeholder="Enter name"
                                        value={this.state.name}
                                        onChange={(e) => {
                                            this.handleValues('name', e.target.value);
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        name="email"
                                        placeholder="Enter email"
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.handleValues('email', e.target.value);
                                        }}
                                    />
                                    <Form.Text className="text-muted">
                                        We'll never share your email with anyone else.
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        name="password"
                                        placeholder="Password"
                                        value={this.state.password}
                                        onChange={(e) => {
                                            this.handleValues('password', e.target.value);
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBasicConfirmPassword">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        value={this.state.confirmPassword}
                                        onChange={(e) => {
                                            this.handleValues('confirmPassword', e.target.value);
                                        }}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleRegisterModalClose}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={this.handleRegister}>
                                Register
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <UploadComponent
                        show={this.state.uploadModalShow}
                        onHide={this.handleUploadModalClose}
                        userEmail={this.state.email}
                    />
                </>
            </div>

        );
    }
}

export default App;